import React from 'react';

// Styles
import styles from './AddQuestionDialog.module.css';
import { IoMdAddCircle } from 'react-icons/io';

// Services
import { getCreatePollQuestionErrors } from '../../../services/Poll';

// Hooks
import { useState, useReducer, useMemo } from 'react';

// Components
import OptionsAddQuestion from '../OptionsAddQuestion/OptionsAddQuestion';
import InfoQuestionAdd from '../InfoQuestionAdd/InfoQuestionAdd';
import CancelConfirmButtons from '../../UI/CancelConfirmButtons/CancelConfirmButtons';

// Reducers
import { questionReducer } from '../../../reducers/poll-reducers';

// Interfaces
import { PollQuestion } from '../../../interfaces/Poll';

// Data
import { DEFAULT_QUESTION } from '../../../reducers/poll-reducers';

// Language
import { useTranslation } from 'react-i18next';

const AddQuestionDialog: React.FC<{
    setShowQuestionDialog: React.Dispatch<React.SetStateAction<boolean>>
    addQuestion: (question: PollQuestion) => void,
    defaultQuestion?: PollQuestion,
    order?: number,
    hasTable: boolean,
}> = ({ setShowQuestionDialog, addQuestion, defaultQuestion, order, hasTable }) => {

    const { t } = useTranslation();

    const initQuestion = useMemo(() => ({ ...DEFAULT_QUESTION, order }), [order]);

    const initializeQuestion = (question: PollQuestion) =>
        ({ ...question, answers: question.answers.map(answer => ({ ...answer, uuid: crypto.randomUUID() })) });


    const [questionState, dispatchQuestion] = useReducer(questionReducer, initializeQuestion(defaultQuestion ?? initQuestion));

    const [errMsg, setErrMsg] = useState<string | null>(null);

    const handleConfirm = () => {

        const err = getCreatePollQuestionErrors(questionState);
        if (err) {
            setErrMsg(t(err));
            return;
        }
        addQuestion(questionState);
        setShowQuestionDialog(false);
    };


    return (
        <div className={`${styles.addQuestionDialog} dialog`}>
            <h1 className='dialogTitle'>{t('add_question')}</h1>
            <div className={styles.addQuestionForm}>
                <InfoQuestionAdd
                    questionType={questionState.inquiry_question_type_id}
                    description={questionState.description}
                    parameterDescription={questionState.parameter_description || ''}
                    required={questionState.required}
                    dispatchQuestion={dispatchQuestion}
                    hasTable={hasTable}
                />
                {questionState.inquiry_question_type_id === 1 &&
                    <div className={styles.optionsWrapper}>
                        {questionState.answers.map(answer =>
                            <OptionsAddQuestion
                                key={answer.uuid}
                                answer={answer}
                                disableDelete={questionState.answers.length <= 2}
                                dispatchQuestion={dispatchQuestion}
                                hasTable={hasTable}
                            />
                        )}
                    </div>
                }
            </div>
            <p className='errorMsg' style={{ marginTop: '8px' }}>{t(errMsg || '')}</p>
            <div className={styles.createQuestionActions}>
                {questionState.inquiry_question_type_id === 1 &&
                    <button className={styles.addOption} onClick={() => dispatchQuestion({ type: 'ADD_ANSWER' })}>
                        {t('add_option')} <IoMdAddCircle />
                    </button>
                }
                <div ><CancelConfirmButtons
                    onCancel={() => setShowQuestionDialog(false)}
                    onConfirm={handleConfirm}
                    customStyles={{ marginTop: '0' }}
                /></div>
            </div>
        </div>
    );
};

export default AddQuestionDialog;